var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Sitio web",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 22.5,
    fill: "none",
    stroke: "#08786F",
    strokeWidth: 4.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#08786F",
    strokeWidth: 4.6,
    strokeLinecap: "round",
    d: "M10.5 32h43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#08786F",
    strokeWidth: 4.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32 9.8c6.1 6.15 9.1 13.55 9.1 22.2S38.1 48.05 32 54.2C25.9 48.05 22.9 40.65 22.9 32S25.9 15.95 32 9.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.1d40d742df9368d461a5a55ce9e4cc56.svg";
export { ForwardRef as ReactComponent };